<template>
  <div class="flex flex-row flex-wrap gap-3" v-if="pagination.links && Array.isArray(pagination.links) && pagination.links.length > 3">
    <template v-for="(page, idx) in pagination.links">
      <button
        v-if="buttonsPermission(page.label)"
        class="hover:scale-[1.1]"
        @click="changePage(
          page.label,
          pagination.links[idx-1],
          pagination.links[idx+1]
        )"
      >
        <card
          v-html="buttonsLabel(page.label)"
          padding="px-3 py-1"
          class="font-bold"
          :class="textClass"
          :bg="page.active ? 'bg-theme text-white':'dark:bg-slate-950 bg-white'"
        ></card>
      </button>
    </template>

    <input
      type="number"
      name="absolutePage"
      v-model="absolutePage"
      @input="absoluteInput"
      class="
        rounded px-1 w-12 outline-0 text-center text-sm font-bold appearance-none
        border border-gray-500/20 dark:border-white/20 dark:bg-slate-950 mx-2
      "
    >
  </div>
</template>


<script>

export default {
  name: "RpmPagination",
  props: {
    pagination: {
      type: Object,
      default: {},
    },
    textClass: {
      type: [String, Array, Object],
      default: "text-sm",
    },
  },
  data() {
    return {
      absolutePage: this.pagination.page,
      inputTimer: null
    }
  },
  methods: {
    changePage(label, previousLabel, nextLabel){
      const page = this.getLabel(
        this.setGoto(label, previousLabel, nextLabel)
      );

      this.$router.push({ path: this.$route.path, query: {page: page} });
      this.$emit('change-page', page);
    },
    setGoto(label, previousLabel, nextLabel){
      if(label !== '...') return label;
      
      if(previousLabel) previousLabel = parseInt(previousLabel.label);
      if(nextLabel) nextLabel = parseInt(nextLabel.label);

      return (Math.round((nextLabel - previousLabel)/2) + previousLabel).toString();
    },
    getLabel(label){
      label = label.toString();

      if(label === '' || label > this.pagination.last_page) return;

      if(label.match(/Previous/)) return this.pagination.page - 1;
      if(label.match(/Next/)) return this.pagination.page + 1;
      return label;
    },
    buttonsPermission(label){
      if(label.match(/Previous/)) return this.pagination.page > 1;
      if(label.match(/Next/)) return this.pagination.page < this.pagination.last_page;
      return true;
    },
    buttonsLabel(label){
      if(label.match(/Previous/)) return '<i class="fa-solid fa-angles-left"></i>';
      if(label.match(/Next/)) return '<i class="fa-solid fa-angles-right"></i>';
      return label;
    },
    absoluteInput(){
      if(this.absolutePage < 1) return;
      if(this.inputTimer) clearTimeout(this.inputTimer);
      this.inputTimer = setTimeout(() => this.changePage(this.absolutePage), 1000);
    },
  },
  watch: {
    absolutePage(newer){
      if(newer === '') return;
      if(newer < 1) this.absolutePage = 1;
      if(!Number.isInteger(newer)) this.absolutePage = Math.round(this.absolutePage);
    },
    'pagination.page'(newer){
      this.absolutePage = newer;
    }
  }
};
</script>
